import React, { useState } from "react";
import {
  Navbar,
  Container,
  Nav,
  Button,
  Toast,
  ToastContainer,
  Offcanvas,
} from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";
import logo from "../../assets/logo.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import Swal from "sweetalert2";

const AdminNavbar = () => {
  const { logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [showLogoutMsg, setShowLogoutMsg] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const handleLogout = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out from LearnSmart.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, log out",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      await logout();
      setShowLogoutMsg(true);
      // Optional: redirect to /login here if routing doesn't handle it
    }
  };

  return (
    <>
      {/* Use expand="lg" so below lg it becomes offcanvas */}
      <Navbar
        expand="lg"
        bg={theme === "light" ? "light" : "dark"}
        data-bs-theme={theme}
        className="mb-3 shadow-sm"
      >
        <Container fluid>
          {/* Brand (logo + name) — stays on the left */}
          <Navbar.Brand href="/admin" className="d-flex align-items-center gap-2">
            <img
              src={logo}
              alt="LearnSmart Logo"
              height="32"
              className="d-inline-block align-top"
            />
            <span className="fw-semibold d-none d-sm-inline">
              LearnSmart — SuperAdmin
            </span>
            <span className="fw-semibold d-inline d-sm-none">LearnSmart</span>
          </Navbar.Brand>

          {/* Toggler shows on mobile */}
          <Navbar.Toggle
            aria-controls="admin-offcanvas"
            onClick={() => setShowMenu(true)}
          />

          {/* Offcanvas menu for mobile, collapses into inline on >= lg */}
          <Navbar.Offcanvas
            id="admin-offcanvas"
            aria-labelledby="admin-offcanvas-label"
            placement="end"
            show={showMenu}
            onHide={() => setShowMenu(false)}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="admin-offcanvas-label" className="d-flex align-items-center gap-2">
                <img src={logo} alt="LearnSmart Logo" height="24" />
                <span>Menu</span>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="ms-auto align-items-lg-center gap-2">
                {/* Theme toggle (looks like an icon button on desktop; full-width on mobile) */}
                <div className="d-flex align-items-center">
                  <Button
                    variant={theme === "light" ? "outline-secondary" : "outline-light"}
                    size="sm"
                    onClick={toggleTheme}
                    title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
                    className="d-flex align-items-center justify-content-center rounded-circle me-2"
                    style={{ width: 34, height: 34 }}
                  >
                    <i className={`bi ${theme === "light" ? "bi-moon" : "bi-sun"}`} />
                  </Button>
                  <span className="text-body-secondary d-none d-lg-inline">
                    {theme === "light" ? "Light" : "Dark"} mode
                  </span>
                </div>

                {/* Logout as a clear action */}
                <Nav.Link
                  onClick={() => {
                    setShowMenu(false); // close menu on mobile
                    handleLogout();
                  }}
                  className="fw-semibold"
                >
                  Logout
                </Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>

      {/* Success toast after logout */}
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg="success"
          onClose={() => setShowLogoutMsg(false)}
          show={showLogoutMsg}
          delay={2000}
          autohide
        >
          <Toast.Header closeButton={false}>
            <strong className="me-auto">Logout</strong>
          </Toast.Header>
          <Toast.Body className="text-white">
            You have been logged out successfully.
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default AdminNavbar;
